// extracted by mini-css-extract-plugin
export default {"div-body":"Card_div-body__EacMY"};